import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AuthGuard from "@/components/AuthGuard";
import AppLayout from "@/components/AppLayout";
import Overview from "@/pages/Overview";
import CandidateArtifacts from "@/pages/CandidateArtifacts";
import ArtifactReview from "@/pages/ArtifactReview";
import Reviews from "@/pages/Reviews";
import EvidenceConsole from "@/pages/EvidenceConsole";
import Revocations from "@/pages/Revocations";
import Policies from "@/pages/Policies";
import PublishedKnowledge from "@/pages/PublishedKnowledge";
import Integrations from "@/pages/Integrations";
import Settings from "@/pages/Settings";
import ToolsHub from "@/pages/tools/ToolsHub";
import GovernanceMaturity from "@/pages/tools/GovernanceMaturity";
import ContributorClassifier from "@/pages/tools/ContributorClassifier";
import PolicyChecker from "@/pages/tools/PolicyChecker";
import ReviewSlaCalculator from "@/pages/tools/ReviewSlaCalculator";
import RevocationRisk from "@/pages/tools/RevocationRisk";
import AiKnowledgeArtifact from "@/pages/glossary/AiKnowledgeArtifact";
import ContributorClass from "@/pages/glossary/ContributorClass";
import AiKnowledgeGovernance from "@/pages/glossary/AiKnowledgeGovernance";
import BlogIndex from "@/pages/blog/BlogIndex";
import BlogPost from "@/pages/blog/BlogPost";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import CookieConsent from "@/components/CookieConsent";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/app"
            element={
              <AuthGuard>
                <AppLayout />
              </AuthGuard>
            }
          >
            <Route index element={<Overview />} />
            <Route path="artifacts" element={<CandidateArtifacts />} />
            <Route path="artifacts/:id" element={<ArtifactReview />} />
            <Route path="reviews" element={<Reviews />} />
            <Route path="evidence" element={<EvidenceConsole />} />
            <Route path="revocations" element={<Revocations />} />
            <Route path="policies" element={<Policies />} />
            <Route path="published" element={<PublishedKnowledge />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="/tools" element={<ToolsHub />} />
          <Route path="/tools/ai-governance-maturity" element={<GovernanceMaturity />} />
          <Route path="/tools/contributor-class-classifier" element={<ContributorClassifier />} />
          <Route path="/tools/policy-checker" element={<PolicyChecker />} />
          <Route path="/tools/review-sla-calculator" element={<ReviewSlaCalculator />} />
          <Route path="/tools/revocation-risk" element={<RevocationRisk />} />
          <Route path="/glossary/ai-knowledge-artifact" element={<AiKnowledgeArtifact />} />
          <Route path="/glossary/contributor-class" element={<ContributorClass />} />
          <Route path="/glossary/ai-knowledge-governance" element={<AiKnowledgeGovernance />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <CookieConsent />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}
